import { render, staticRenderFns } from "./CompactEditLiteralComponent.vue?vue&type=template&id=922c85b6&scoped=true&"
import script from "./CompactEditLiteralComponent.vue?vue&type=script&lang=js&"
export * from "./CompactEditLiteralComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompactEditLiteralComponent.vue?vue&type=style&index=0&id=922c85b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922c85b6",
  null
  
)

export default component.exports